import { blobToBinary } from "utils/miscUtils";
import sessionHelper from "./sessionHelper";

async function uploadImage(params: any) {
  try {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", params?.fileType ?? "image/png");

    const file = await blobToBinary(params.data);

    const requestOptions: any = {
      method: "PUT",
      headers: myHeaders,
      body: file,
      redirect: "follow",
    };

    const response = fetch(params?.url, requestOptions);

    return response;
  } catch (error) {
    throw error;
  }
}

async function uploadImageV2(params: any) {
  try {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${sessionHelper?.token}`);

    const formData = new FormData();
    formData.append("image", params.data, "image.webp");
    formData.append("uploadUrl", params.uploadUrl);

    formData.append("resize", params.resize ?? false);
    formData.append("resizeToWidth", params.resizeToWidth ?? 0);
    formData.append("resizeToHeight", params.resizeToHeight ?? 0);

    const requestOptions: any = {
      method: "PUT",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };
    let url = `${import.meta.env.VITE_CMS_API_URL}/misc/handleImageUpload`;
    const response = await fetch(url, requestOptions);

    return await response.json();
  } catch (error) {
    throw error;
  }
}

async function uploadTranslation(file: any) {
  try {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${sessionHelper?.token}`);

    const formData = new FormData();
    formData.append("file", file);

    const req: any = {
      method: "POST",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };
    let url = `${import.meta.env.VITE_CMS_API_URL}/misc/uploadTranslations`;
    const response = await fetch(url, req);

    return await response.json();
  } catch (error) {
    throw error;
  }
}

async function uploadContentTranslations(
  file: File,
  assetType: string,
  assetId: string,
) {
  try {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${sessionHelper?.token}`);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("assetType", assetType);
    formData.append("assetId", assetId);

    const req: any = {
      method: "POST",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };
    let url = `${import.meta.env.VITE_CMS_API_URL}/misc/uploadContentTranslations`;
    const response = await fetch(url, req);

    return await response.json();
  } catch (error) {
    throw error;
  }
}

export {
  uploadImage,
  uploadTranslation,
  uploadImageV2,
  uploadContentTranslations,
};
